import { Component } from 'react'
import styles from '~/styles/ordersPage.chartStatus.module.css'
import types from '~/types/ordersPage.ts'

export default class ChartStatus extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}
	
	constructor(props) {
		super(props)
	}

	render(): JSX.Element {
		if (this.props.show) {
			let title = this.props.t('Status from chart')
			let isFromChart = this.props.chartNpsType || this.props.chartBopa || this.props.chartDayStratification || this.props.chartDeliveryReturnType || this.props.chartNpsPerIntervalType
			if (isFromChart) {
				title = this.props.t('From chart')
			}
			let titleValue = this.props.chartStatus || this.props.chartNpsType || this.props.chartBopa || this.props.chartDeliveryReturnType
			let titleI18nValue = this.props.t(titleValue)
			if (this.props.chartDayStratification) {
				titleValue = 'Delivery Stratification'
				if (this.props.chartDayStratification.stratificationType === 'retention') {
					titleValue = 'Retention Stratification'
				} else if (this.props.chartDayStratification.stratificationType === 'clickToShip') {
					titleValue = 'Click to Ship'
				}
				titleI18nValue = this.props.t(titleValue) 
				titleI18nValue += ', day ' + this.props.chartDayStratification.day
				let sign = ''
				if (this.props.chartDayStratification.stratificationType === 'delivery') {
					if (this.props.chartDayStratification.part === 1) {
						sign = '<'
					} else if (this.props.chartDayStratification.part === 3) {
						sign = '>'
					}
				}
				if (sign) {
					titleI18nValue += ` (${sign})`
				}
			} else if (this.props.chartNpsPerIntervalType) {
				titleI18nValue = 'NPS'
			}
			return (
				<div
					className={styles.main}
				>
					<div
						className={styles.chartStatus}
					>
						<div>
							<div className={styles.title}>
								{title}:
							</div>
							<div>
								{titleI18nValue}
							</div>
							{this._getCityOrRegion()}
						</div>
					</div>
					<div 
						className={styles.button}
						onClick={this._onClick.bind(this)}
					>
						{this.props.t('Reset filter')}
					</div>
				</div>
			)
		} else {
			return null
		}
	}

	private _getCityOrRegion() {
		if (this.props.chartCityOrRegion) {
			return (
				<>
					<div className={styles.title}>
						, {this.props.chartIsRegion ? this.props.t('region') : this.props.t('city')}:
					</div>
					<div>
						{this.props.chartCityOrRegion}
					</div>
				</>
			)
		} else {
			return null
		}
	}	

	private _onClick() {
		if (typeof this.props.removeChartDateAndStatus === 'function') {
			this.props.removeChartDateAndStatus()
		}
	}
}